import { storyblokEditable } from "@storyblok/react";

const IconsWithButton = ({ blok }) => (
  <div className="">
    <div
      className="imgtextleft-wrap"
      {...storyblokEditable(blok)}
    >
      <div className="imgtextleft-contentLeft">
        <img
          className="imgtextleft-image"
          src={blok.image.filename}
          alt={blok.image.alt}
        />
      </div>

      <div className="imgtextleft-contentRight">
        <div className="imgtextleft-content">
          <h2 className="imgtextleft-subheadline text-6xl">{blok.subheadline}</h2>

          {blok.infotext && <p className="pb-3">{blok.infotext}</p>}
          {blok.infotext2 && <p className="pb-3">{blok.infotext2}</p>}
          {blok.infotext3 && <p className="pb-3">{blok.infotext3}</p>}
          {blok.infotext4 && <p className="pb-3">{blok.infotext4}</p>}
          {blok.infotext5 && <p className="pb-3">{blok.infotext5}</p>}
        </div>
      </div>


    </div>
  </div>
);
export default IconsWithButton;
